module.exports = "/images/vendor/flag-icon-css/flags/1x1/bi.svg?75d5af3debe2895f5eb256ea01ab2458";